import * as React from 'react';
import { Field } from 'redux-form';
import { PortalInputField } from 'components/FormControls/PortalInputField';

interface IProps {
	t?: (key: string) => string;
	label: string;
	placeholder?: string;
	validate?: any[];
}

/**
 *
 * @param props
 */
export const PhoneNumber = (props: IProps) => {
	return (
		<Field name="telephone" component={PortalInputField} type="text" validate={props.validate} label={props.label} />
	);
};
